import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import Header from './components/Header';
import Gallery from './components/Gallery';
import Listmember from './components/Listmember';
import About from './components/About';
import JoinClanInfo from './components/JoinClanInfo';
import JoinForm from './components/JoinForm';
import Footer from './components/Footer';
import DiscordLogin from './components/DiscordLogin';
import './App.css';

library.add(faDiscord);

function MainContent() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/rekruitmen') {
      const element = document.getElementById('join-clan-info');
      if (element) {
        element.scrollIntoView();
        window.scrollBy(0, -100);
      }
    }
  }, [location.pathname]);

  return (
    <>
      <section id="home" className="welcome-section">
        <h1 className="welcome-title">The Family Haven</h1>
        <p className="welcome-text">
          Thank you for visiting The Family Haven Album Gallery,
          saving and sharing unforgettable precious moments. Here,
          every photo has an unforgettable story, and every memory
          will always live on.
        </p>
      </section>
      <section id="gallery">
        <Gallery />
      </section>
      <section id="member">
        <Listmember />
      </section>
      <section id="join-clan-info">
        <JoinClanInfo />
      </section>
      <section id="about">
        <About />
      </section>
    </>
  );
}

function App() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);

  return (
    <Router>
      <div className="app">
        <Header />
        <main>
          <Routes>
            <Route path="/auth/discord/callback" element={<DiscordLogin />} />
            <Route path="/" element={<MainContent />} />
            <Route path="/rekruitmen" element={<MainContent />} />
            <Route path="/join-form" element={<JoinForm />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;